import React from "react";
import "./settings.scss";
import Settingstab from "./settingstab";
import Information from "./information";
import UserManagement from "./usermanagement";
import { useParams } from "react-router-dom";

export default function Settings() {
  const { route } = useParams();

  return (
    <div>
      <Settingstab />
      {route === "account" && (
        <>
          <Information />
        </>
      )}
      {route === "users" && <UserManagement />}
    </div>
  );
}
